import { getStoredUserProfile } from './authStorage';

function normalizeString(value) {
  if (typeof value !== 'string') return '';
  return value.trim();
}

function normalizeEmail(email) {
  return normalizeString(email).toLowerCase();
}

export function resolveUserIdentity(userLike) {
  const storedProfile = getStoredUserProfile();
  const source = userLike || storedProfile || null;

  const profileUserId = normalizeString(source?.uid) || normalizeString(source?.sub);
  const storedUserId = normalizeString(
    typeof window !== 'undefined' ? window.localStorage.getItem('user_id') : ''
  );
  const email = normalizeEmail(source?.email);
  const userId = profileUserId || storedUserId || null;

  return {
    userId,
    email: email || '',
    hasIdentity: Boolean(userId || email),
  };
}

export function buildPlanLookupQuery(identity) {
  const params = new URLSearchParams();
  if (identity?.userId) {
    params.set('userId', identity.userId);
  }
  if (identity?.email) {
    params.set('email', identity.email);
  }
  return params.toString();
}

export function getUserIdentityCacheKey(identity) {
  if (identity?.email) {
    return `email:${identity.email}`;
  }
  if (identity?.userId) {
    return `user:${identity.userId}`;
  }
  return '';
}
